import React from "react";
import FuxEvents from "../../../../lib/FuxFramework/FuxEvents";
import {DLA_PRENOTAZIONE_GRUPPO_QR} from "../../../../const/DeepLinkActionsCostants";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import {PrenotazioneGruppoQRInfoPanel} from "./PrenotazioneGruppoQRInfoPanel";

export class PrenotazioneGruppoQRScanListener extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id_prenotazione: null,
            password: null,
            ticket_id: null
        }
    }

    componentDidMount() {
        FuxEvents.on(DLA_PRENOTAZIONE_GRUPPO_QR, this.handleOpenPanel)
    }

    componentWillUnmount() {
        FuxEvents.off(DLA_PRENOTAZIONE_GRUPPO_QR, this.handleOpenPanel);
    }

    handleOpenPanel = params =>{
        const code = params.split("_");

        const id_prenotazione = code[0];
        const password = code[1];
        const ticket_id = code[2] || null; // if missing, use null

        console.log(id_prenotazione, password, ticket_id);

        this.setState({id_prenotazione: id_prenotazione, password: password, ticket_id: ticket_id});
    }

    handleDismissResume = _ => this.setState({id_prenotazione: null, password: null, ticket_id: null});


    render() {
        if (!this.state.id_prenotazione) return '';
        return (
            <ModalPortalHOC>
                <PrenotazioneGruppoQRInfoPanel
                    idPrenotazione={this.state.id_prenotazione}
                    password={this.state.password}
                    ticketId={this.state.ticket_id}
                    onDismiss={this.handleDismissResume}
                />
            </ModalPortalHOC>
        )
    }

}

PrenotazioneGruppoQRScanListener.propTypes = {

}